/**
 * 消息中心
 */

import { smb_fetch, getAgpApiUrl } from "@/api/operator/fetch"

/**
 * 获取公告列表
 */
export const getNoticeList = (data) => {
  const url = getAgpApiUrl("notice", "get_list")
  const params = $.extend(
    true,
    {
      method: "GET",
    },
    data
  )
  return smb_fetch(url, params, true)
}

/**
 * 获取类目列表
 */
export const getCategoryList = (data) => {
  const url = getAgpApiUrl("notice", "get_category_list")
  const params = $.extend(
    true,
    {
      method: "GET",
    },
    data
  )
  return smb_fetch(url, params, true)
}

/**
 * 阅读公告
 */
export const readNotice = (data) => {
  const url = getAgpApiUrl("notice", "read")
  const params = $.extend(
    true,
    {
      method: "POST",
    },
    data
  )
  return smb_fetch(url, params, true)
}

/**
 * 获取公告详情
 */
export const getNotice = (data) => {
  const url = getAgpApiUrl("notice", "get_notice")
  const params = $.extend(
    true,
    {
      method: "GET",
    },
    data
  )
  return smb_fetch(url, params, true)
}
